import { Setup } from './Setup';

export class DocumentList {
  initDocumentList() {
    // addEventListener to all submit-buttons for each document in list
    const forms  = document.getElementsByClassName('form-documentshop');
    for (let i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', event => {
        // stop form submission
        event.preventDefault();

        const form = event.target as HTMLFormElement;

        fetch(Setup.API_BASE_PATH + 'addToBasket', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            'document': parseInt(form.elements['form-documentshop-document'].value, 10),
            'language': form.elements['form-documentshop-language'].value,
          }),
        })
          .then(response => response.json())
          .then((ret: {basketArticleCount: number}) => {

            const submitButton = form.querySelector('.vrs-documentshop-item__form-content > button[type="submit"]') as HTMLButtonElement;
            const hint = form.querySelector('.vrs-documentshop-item__form-content > span.button--added') as HTMLSpanElement;
            const basketArticleCountSpans = document.querySelectorAll('.js-basket-article-count');

            basketArticleCountSpans.forEach(
              (basketArticleCountSpan: HTMLSpanElement) => basketArticleCountSpan.innerText = ret.basketArticleCount.toString(),
            );
            // set confirmation hint for only 3 seconds instead of submit button
            submitButton.classList.add('hide');
            hint.classList.remove('hide');
            setTimeout(
              () => {
                submitButton.classList.remove('hide');
                hint.classList.add('hide');
              },
              3000,
            );
          });
      });
    }

    this.handleDocumentLanguageChanged();
  }

  /********************
   * LANGUAGE CHANGED *
   ********************/

  private handleDocumentLanguageChanged() {
    // addEventListener to all address form inputs
    const languageSelects = document.getElementsByClassName('js-documentshop-select-language');
    for (let i = 0; i < languageSelects.length; i++) {
      languageSelects[i].addEventListener('change', event => {

        const documentUid = languageSelects[i].getAttribute('data-document-uid');
        const language = (event.target as HTMLSelectElement).value;

        const documentForm = document.getElementById('form-documentshop-' + documentUid) as HTMLFormElement;
        const isPrintVersionDe = documentForm.getAttribute('data-document-isPrintVersionDe') === 'true'; // convert string 'true' to boolean
        const isPrintVersionEn = documentForm.getAttribute('data-document-isPrintVersionEn') === 'true'; // convert string 'true' to boolean

        this.switchDocumentCoverByLanguage(language, documentUid);
        this.switchPdfDownloadButton(language, documentUid);
        this.setBasketSubmitButtonStatus(language, documentUid, isPrintVersionDe, isPrintVersionEn);
      });
    }
  }

  private switchDocumentCoverByLanguage(language, documentUid) {
    const coverDe = document.getElementById('document-' + documentUid + '-coverImage-de') as HTMLElement;
    const coverEn = document.getElementById('document-' + documentUid + '-coverImage-en') as HTMLElement;

    switch (language) {
      case 'de':
        coverDe.classList.remove('hide');
        coverEn.classList.add('hide');
        break;
      case 'en':
        coverEn.classList.remove('hide');
        coverDe.classList.add('hide');
        break;
      default:
        break;
    }
  }

  private switchPdfDownloadButton(language, documentUid) {
    // can be empty
    const pdfDownloadButtonDe = document.getElementById('document-' + documentUid + '-pdf-download-de');
    const pdfDownloadButtonEn = document.getElementById('document-' + documentUid + '-pdf-download-en');

    switch (language) {
      case 'de':
        pdfDownloadButtonDe?.classList.remove('hide');
        pdfDownloadButtonEn?.classList.add('hide');
        break;
      case 'en':
        pdfDownloadButtonEn?.classList.remove('hide');
        pdfDownloadButtonDe?.classList.add('hide');
        break;
      default:
        break;
    }
  }

  /**
   * hide submit button, when printversion is not available in selected language
   */
  private setBasketSubmitButtonStatus(language, documentUid, isPrintVersionDe, isPrintVersionEn) {
    const addToBasketSubmitButton = document.getElementById('document-' + documentUid + '-add-to-basket-submit-button') as HTMLButtonElement;

    let showButton = false;
    switch (language) {
      case 'de':
        showButton = isPrintVersionDe;
        break;
      case 'en':
        showButton = isPrintVersionEn;
        break;
      default:
        break;
    }

    if (showButton) {
      addToBasketSubmitButton.classList.remove('hide');
    } else {
      addToBasketSubmitButton.classList.add('hide');
    }
  }
}
